import { Primary } from '@cinch-labs/design-system'
import styles from './cta-button.module.css'

export type CtaButtonProps = {
  label: string
  url: string
}

export const CtaButton: React.FC<CtaButtonProps> = ({ label, url }) => (
  <div className={styles.ctaButton}>
    <Primary element="a" href={url}>
      {label}
    </Primary>
  </div>
)
